/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function GradientRadialFarthestSide(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'GradientRadialFarthestSide',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"opacity":".6","fillRule":"evenodd","clipRule":"evenodd","d":"M13 2H2v12h11v1H1V1h12v1z","fill":"currentColor"}),createElement('path', {"opacity":".4","fillRule":"evenodd","clipRule":"evenodd","d":"M13.85 5a7.465 7.465 0 00-1.35-3H2v10.5A7.503 7.503 0 0013.85 8H8.5a2.5 2.5 0 110-3h5.35z","fill":"currentColor"}),createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M14 1h1v14h-1V7H8.95a2.513 2.513 0 000-1H14V1z","fill":"currentColor"}),createElement('circle', {"cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(5 5)","fill":"currentColor"}))
}
